(function () {
  function setHeaderHeightVar() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--kg-header-height', h + 'px');
  }

  function init() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var threshold = 24;

    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeaderHeightVar);
    }
    setTimeout(setHeaderHeightVar, 300);

    function onScroll() {
      if (window.scrollY > threshold) {
        header.classList.add('kg-header--scrolled');
      } else {
        header.classList.remove('kg-header--scrolled');
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
